import React from 'react';

import { Rectangle, SkeletonContainer } from '../../../LoadingSkeletons';

import { BodyStyles } from './Body.styles';
import type { InstagramStoryComponentsProps } from './types';

export function Body(props: InstagramStoryComponentsProps): React.JSX.Element {
	const { size, loading, previewImageUrl } = props;

	const styles = BodyStyles({ size });

	if (loading) {
		return (
			<SkeletonContainer
				loading={loading}
				className={styles}
				shapeColorClassName="bg-icon-weak"
				data-testid="empty-container"
			>
				<Rectangle className="h-full w-full" />
			</SkeletonContainer>
		);
	}

	return <img data-testid="body-image" className={styles} src={previewImageUrl} alt="" aria-hidden />;
}
